import {
	Row,
	Col,
	Button,
	Flex,
	Drawer,
	Tabs,
	Typography,
	Checkbox,
} from "antd";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import dayjs from "dayjs";
import { GET } from "../../../providers/useAxiosQuery";

import PreferredExamCalendar from "./components/PreferredExamCalendar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
	faCalendarDay,
	faChevronRight,
	faMemo,
	faMemoCircleCheck,
} from "@fortawesome/pro-regular-svg-icons";

import TableApplicant from "./components/TableApplicant";
import TableExamStatus from "./components/TableExamStatus";
import TableExamResult from "./components/TableExamResult";
import PageApplicantContext from "./components/PageApplicantContext";
import { TableDropdownFilter } from "../../../providers/CustomTableFilter";

export default function PageApplicant() {
	const location = useLocation();

	const [tabActive, setTabActive] = useState(
		location.pathname.includes("walk-in")
			? "Walk-In List View"
			: location.pathname.includes("online")
			? "Online List View"
			: "Archived List View"
	);
	const [openDrawerFilter, setOpenDrawerFilter] = useState(false);
	const [examScheduleFilter, setExamScheduleFilter] = useState([]);

	const [labelKeyObject, setLabelKeyObject] = useState({
		label: location.pathname.includes("walk-in")
			? "Walk-In List View"
			: "Online List View",
		key: location.pathname.includes("walk-in")
			? "Walk-In List View"
			: "Online List View",
	});

	const [toggleModalDataConsent, setToggleModalDataConsent] = useState({
		open: false,
		data: null,
	});

	const [toggleModalFormValidation, setToggleModalFormValidation] = useState({
		open: false,
		data: null,
	});

	const [tableFilter, setTableFilter] = useState({
		page: 1,
		page_size: 50,
		search: "",
		sort_field: "created_at",
		sort_order: "desc",
		category: ["College", "College of Law", "Graduate Studies"],
		payment_status: ["Not Paid", "Paid"],
		from: location.pathname.includes("walk-in")
			? "walk-in"
			: location.pathname.includes("online")
			? "online"
			: "archived",
		tabActive: location.pathname.includes("walk-in")
			? "Walk-In List View"
			: location.pathname.includes("online")
			? "Online List View"
			: "Archived List View",
		exam_schedule_id: "",
		exam_status: "",
	});

	useEffect(() => {
		setTableFilter({
			page: 1,
			page_size: 50,
			search: "",
			sort_field: "created_at",
			sort_order: "desc",
			category: ["College", "College of Law", "Graduate Studies"],
			payment_status: ["Not Paid", "Paid"],
			status:
				location.pathname.includes("walk-in") ||
				location.pathname.includes("online")
					? "Active"
					: "Deactivated",
			from: location.pathname.includes("walk-in")
				? "walk-in"
				: location.pathname.includes("online")
				? "online"
				: "archived",
			tabActive: location.pathname.includes("walk-in")
				? "Walk-In List View"
				: location.pathname.includes("online")
				? "Online List View"
				: "Archived List View",
			exam_schedule_id: "",
			exam_status: "",
			isTrash: 0,
		});

		setLabelKeyObject({
			label: location.pathname.includes("walk-in")
				? "Walk-In List View"
				: "Online List View",
			key: location.pathname.includes("walk-in")
				? "Walk-In List View"
				: "Online List View",
		});
		return () => {};
	}, [location]);

	const { data: dataExamCategory } = GET(
		`api/exam_category`,
		"exam_category_list"
	);

	const {
		data: dataStudentExam,
		refetch: refetchStudentExam,
	} = GET(
		`api/student_exams?${new URLSearchParams(tableFilter)}`,
		"student_exams_list",
		(res) => {}
	);

	useEffect(() => {
		refetchStudentExam();

		if (tableFilter.exam_schedule_id !== "All") {
			const examSchedule = dataStudentExam?.dataExamSchedules?.find(
				(item) => item.id === tableFilter.exam_schedule_id
			);

			setExamScheduleFilter(examSchedule);
		}

		return () => {};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [tableFilter, setExamScheduleFilter]);

	const renderFilter = () => (
		<Flex gap={10}>
			<Button
				type="primary"
				onClick={() => {
					setTableFilter((ps) => ({
						...ps,
						exam_schedule_id: "All",
					}));
				}}
			>
				View All Scheduled
			</Button>

			<TableDropdownFilter
				items={
					dataExamCategory &&
					dataExamCategory.data && [
						{
							key: "exam_schedule_id",
							label: (
								<Flex justify="space-between" align="center">
									<Button
										type="text"
										color="default"
										className="pl-0 btn-filter-exam-schedule"
										onClick={() => setOpenDrawerFilter(true)}
									>
										Exam Schedule
									</Button>
									<FontAwesomeIcon icon={faChevronRight} />
								</Flex>
							),
						},
						{
							key: "category",
							label: "Exam Category",
							children: dataExamCategory.data.map((item) => {
								const isChecked =
									tableFilter?.category?.includes(item.category) || false;

								const handleCheckboxChange = (e) => {
									let updatedCategory = tableFilter?.category || [];
									if (e.target.checked) {
										if (!updatedCategory.includes(item.category)) {
											updatedCategory.push(item.category);
										}
									} else {
										updatedCategory = updatedCategory.filter(
											(f) => f !== item.category
										);
									}

									setTableFilter((prevState) => ({
										...prevState,
										category: updatedCategory,
									}));
								};

								return {
									key: item.id.toString(),
									label: (
										<div>
											<Checkbox
												id={`chck_${item.category}`}
												checked={isChecked}
												onChange={handleCheckboxChange}
											/>
											<label htmlFor={`chck_${item.category}`}>
												{item.category}
											</label>
										</div>
									),
								};
							}),
						},
						tableFilter.tabActive === "Walk-In List View" && {
							key: "payment_status",
							label: "Payment Status",
							children: [
								{
									key: "paid",
									label: (
										<div>
											<Checkbox
												id="chck_paid"
												checked={
													tableFilter &&
													tableFilter.payment_status &&
													tableFilter.payment_status.includes("Paid")
												}
												onChange={(e) => {
													let payment_status =
														tableFilter && tableFilter.payment_status
															? tableFilter.payment_status
															: [];
													if (e.target.checked) {
														if (!payment_status.includes("Paid")) {
															payment_status.push("Paid");
														}
													} else {
														payment_status = payment_status.filter(
															(status) => status !== "Paid"
														);
													}

													setTableFilter((ps) => ({
														...ps,
														payment_status,
													}));
												}}
											/>
											<label htmlFor="chck_paid">Paid</label>
										</div>
									),
								},
								{
									key: "not_paid",
									label: (
										<div>
											<Checkbox
												id="chck_not_paid"
												checked={
													tableFilter &&
													tableFilter.payment_status &&
													tableFilter.payment_status.includes("Not Paid")
												}
												onChange={(e) => {
													let payment_status =
														tableFilter && tableFilter.payment_status
															? tableFilter.payment_status
															: [];
													if (e.target.checked) {
														if (!payment_status.includes("Not Paid")) {
															payment_status.push("Not Paid");
														}
													} else {
														payment_status = payment_status.filter(
															(status) => status !== "Not Paid"
														);
													}

													setTableFilter((ps) => ({
														...ps,
														payment_status,
													}));
												}}
											/>
											<label htmlFor="chck_not_paid">Not Paid</label>
										</div>
									),
								},
							],
						},
					]
				}
			/>

			{(location.pathname === "/applicants/walk-in" ||
				location.pathname === "/applicants/online") && (
				<Flex gap={10}>
					{tableFilter.exam_schedule_id !== "All" && examScheduleFilter && (
						<Flex gap={20} align="center">
							<Typography.Title level={5} className="m-0">
								<span style={{ fontWeight: "normal" }}>Date:</span>{" "}
								<span className="pr-20" style={{ color: "#447ce2" }}>
									{examScheduleFilter
										? dayjs(examScheduleFilter.exam_date).format(
												"MMMM DD, YYYY"
										  )
										: "???"}
								</span>
								<span style={{ fontWeight: "normal" }}>Time:</span>{" "}
								<span className="pr-20" style={{ color: "#447ce2" }}>
									{examScheduleFilter ? (
										<>
											{examScheduleFilter.time_in}{" "}
											{examScheduleFilter.time_in_meridiem} -{" "}
											{examScheduleFilter.time_out}{" "}
											{examScheduleFilter.time_out_meridiem}
										</>
									) : (
										"???"
									)}
								</span>
								<span style={{ fontWeight: "normal" }}>Available Slot/s:</span>{" "}
								<span className="pr-20" style={{ color: "#447ce2" }}>
									{examScheduleFilter
										? examScheduleFilter.total_available_slot
										: "???"}
								</span>
							</Typography.Title>
						</Flex>
					)}
				</Flex>
			)}
		</Flex>
	);

	return (
		<PageApplicantContext.Provider
			value={{
				location,
				tabActive,
				tableFilter,
				setTableFilter,

				dataExamCategory: dataExamCategory ? dataExamCategory.data : [],
				dataStudentExam,

				toggleModalDataConsent,
				setToggleModalDataConsent,
				toggleModalFormValidation,
				setToggleModalFormValidation,
			}}
		>
			<Row gutter={[12, 12]}>
				<Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
					{renderFilter()}

					<Tabs
						className="TABS"
						indicator={{
							size: (origin) => origin - 25,
							align: "end",
						}}
						defaultActiveKey="1"
						onChange={(key) => {
							let exam_status = "";
							if (key === "Exam Status List View") {
								exam_status = "Not Taken";
							}
							setTableFilter((ps) => ({ ...ps, tabActive: key, exam_status }));
						}}
						items={[
							{
								icon: <FontAwesomeIcon icon={faCalendarDay} />,
								label: labelKeyObject.label,
								key: labelKeyObject.key,
								children: <TableApplicant />,
							},
							{
								icon: <FontAwesomeIcon icon={faMemo} />,
								label: "Exam Status List View",
								key: "Exam Status List View",
								children: <TableExamStatus />,
							},
							{
								icon: <FontAwesomeIcon icon={faMemoCircleCheck} />,
								label: "Exam Result List View",
								key: "Exam Result List View",
								children: <TableExamResult />,
							},
						]}
					/>
				</Col>
			</Row>

			<Drawer
				title={
					<div style={{ textAlign: "right" }}>Filter by Exam Schedule</div>
				}
				onClose={() => {
					setOpenDrawerFilter(false);
				}}
				open={openDrawerFilter}
				size="large"
				width="800px"
				id="PageApplicant"
			>
				<PreferredExamCalendar
					dataStudentExam={dataStudentExam}
					setTableFilter={setTableFilter}
				/>
			</Drawer>
		</PageApplicantContext.Provider>
	);
}
